import { constants } from '@yola/subscription-manager-js';

const {
  SubscriptionTerm: { MONTHLY },
} = constants;

const isSpecialOfferAvailable = ({
  bundledSubscriptionType,
  extraPriceType,
  activeHostingSubscription,
}) => {
  if (!extraPriceType) {
    return false;
  }

  if (bundledSubscriptionType) {
    return true;
  }

  if (activeHostingSubscription?.term === MONTHLY) {
    return false;
  }

  return true;
};

export default isSpecialOfferAvailable;
